/*
  GDP: 商品画像の明度で左上ラベル（ランキング番号・NEW）の文字色を出し分ける
  画像左上 20% 四方の平均輝度を測り、暗ければ .product-card__figure に data-contrast="dark"（白文字）、明るければ "light"（黒文字）を付与。
  Shopify CDN の画像は CORS 許可されているため crossOrigin 付きで再取得して canvas で解析する（キャッシュ利用）。
*/
(function () {
  'use strict';

  var SELECTOR = '.product-card__figure';
  var LABELS = '.product-card__rank, .product-new-label, .badge--new';
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return;

  function analyze(figure) {
    if (figure.hasAttribute('data-contrast') || figure.hasAttribute('data-contrast-pending')) return;
    if (!figure.querySelector(LABELS)) return;
    var img = figure.querySelector('.product-card__image--primary');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    figure.setAttribute('data-contrast-pending', '');

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = Math.max(1, Math.round(probe.naturalWidth * 0.2));
        var h = Math.max(1, Math.round(probe.naturalHeight * 0.2));
        canvas.width = 16; canvas.height = 16;
        ctx.drawImage(probe, 0, 0, w, h, 0, 0, 16, 16);
        var data = ctx.getImageData(0, 0, 16, 16).data;
        var sum = 0, n = 0;
        for (var i = 0; i < data.length; i += 4) {
          var a = data[i + 3] / 255;
          /* 透過は白背景に合成 */
          var r = data[i] * a + 255 * (1 - a), g = data[i + 1] * a + 255 * (1 - a), b = data[i + 2] * a + 255 * (1 - a);
          sum += 0.2126 * r + 0.7152 * g + 0.0722 * b; n++;
        }
        var lum = sum / n;
        figure.removeAttribute('data-contrast-pending');
        figure.setAttribute('data-contrast', lum < 140 ? 'dark' : 'light');
      } catch (e) {
        /* 解析不可（CORS 等）の場合は既定（白＋影）のまま */
        figure.removeAttribute('data-contrast-pending');
      }
    };
    probe.onerror = function () { figure.removeAttribute('data-contrast-pending'); };
    probe.src = src;
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(analyze);
    if (root && root.matches && root.matches(SELECTOR)) analyze(root);
    var closest = root && root.closest && root.closest(SELECTOR);
    if (closest) analyze(closest);
  }

  function init() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
      });
    }).observe(document.body, { childList: true, subtree: true });
    /* スウォッチ切替でメイン画像が差し替わった場合は再判定 */
    document.addEventListener('change', function (e) {
      var figure = e.target.closest && e.target.closest('.product-card__figure');
      if (figure) { figure.removeAttribute('data-contrast'); figure.removeAttribute('data-contrast-pending'); setTimeout(function () { analyze(figure); }, 350); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
